'use strict';

var Reflux        = require('reflux'),
    React         = require('react'),
    _             = require('underscore'),
    classnames    = require('classnames'),
    TextInput     = require('js/screens/form/input/text.jsx'),
    DropdownInput = require('js/screens/form/input/dropdown.jsx'),
    Country       = require('js/shared/utils/country.js'),
    PageMixin     = require('js/shared/utils/page-mixin.js');

var COUNTRIES = Country.getCountryList();

var UniversityCreationModal = React.createClass({

  propTypes: {
    handleDismiss: React.PropTypes.func,
    handleCreate: React.PropTypes.func,

    defaultSchoolName: React.PropTypes.string
  },

  getDefaultProps: function() {
    return {
      defaultSchoolName: ""
    };
  },

  getInitialState: function() {
    return {
      schoolName: this.props.defaultSchoolName,
      institutionType: "post-secondary",
      country: "Canada"
    };
  },

  _updateInstitutionType: function(value) {
    this.setState({
      institutionType: value.toLowerCase().replace(" ", "_")
    });
  },

  _handleAddButton: function() {
    if (this.state.schoolName === "") return;
    this.props.handleCreate(this.state.schoolName, this.state.country, this.state.institutionType);
  },

  _handleCountryChange: function(value) {
    this.setState({
      country: value
    });
  },

  _handleSchoolChange: function(value) {
    this.setState({
      schoolName: value
    });
  },

  render: function() {
    var cancelButtonClassNames = classnames([
      'htn-button',
      'htn-button--secondary',
      'htn-button--cancel'
    ]);

    var addButtonClassNames = classnames([
      'htn-button',
      'htn-button--primary',
      'htn-button--add'
    ]);

    var removeButtonClassNames = classnames([
      'UniversityCreationModal-removeButton',
      'fa',
      'fa-times'
    ]);

    var error = null;
    if (this.state.schoolName === "") {
      error = "Please enter in a school name.";
    }
    else if (this.state.country === null) {
      error = "Please select a country";
    }


    return (
      <div className="UniversityCreationModal">
        <div className="UniversityCreationModal-container">
          <div className="UniversityCreationModal-title">Add a new school</div>
          <div className={removeButtonClassNames} onClick={this.props.handleDismiss}></div>

          <div className="UniversityCreationModal-question UniversityCreationModal-question--first">
            <TextInput
              value={this.state.schoolName}
              title="School name"
              fieldName="createModalSchoolname"
              autoFocus
              handleChange={this._handleSchoolChange} />
          </div>

          <div className="UniversityCreationModal-question">
            <DropdownInput
              value={this.state.country}
              fieldName="createModalCountry"
              title="Country"
              options={COUNTRIES}
              handleChange={this._handleCountryChange} />
          </div>

          <div className="UniversityCreationModal-question UniversityCreationModal-question--last">
            <div>Type</div>
            {_.map(["Post-secondary", "High school", "Middle school"], (institutionType, idx) =>
              (<label className="QuestionInput-radioContainer QuestionInput-radioButton--uniModal">
                <input
                  className="QuestionInput-radioButton"
                  type="radio"
                  defaultChecked={idx === 0}
                  onClick={this._updateInstitutionType.bind(null, institutionType)}
                  name="institution_type"/>
                <span className="QuestionInput-radioLabel">{institutionType}</span>
              </label>
              )
            )}
          </div>

          <div className="QuestionError QuestionError--uniModal">
            {error}
          </div>

          <div>
            <div
              className={cancelButtonClassNames}
              onClick={this.props.handleDismiss}>Cancel</div>
            <div
              className={addButtonClassNames}
              onClick={this._handleAddButton}>Add</div>
          </div>

        </div>
      </div>
    );
  }
});

module.exports = UniversityCreationModal;



/** WEBPACK FOOTER **
 ** ./js/screens/form/universitycreation-modal.jsx
 **/